import { Outlet } from "react-router-dom";
import { ColumnContainer, RowContainer } from "./styles";

export const NavTab: React.FC = () => {
  return (
    <ColumnContainer>
      {/* <Page.CHeader /> */}
      <RowContainer>
        <Outlet />
      </RowContainer>
    </ColumnContainer>
  );
};
